import { Injectable } from '@angular/core';
import { TabVm } from 'qp-ui-interface';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  public tabsLoaded = false;
  public tabsInfo: TabVm[] = [];
  private currenttabid = '';
  private currenttabname: any = {};

  get currentTabId(): string {
    return this.currenttabid || this.tabsInfo?.[0]?.id;
  }

  set currentTabId(tabId: string) {
    this.currenttabid = tabId;
  }

  get currentTabName(): any {
    return this.currenttabname || this.tabsInfo?.[0]?.name;
  }

  set currentTabName(tabName: any) {
    this.currenttabname = tabName;
  }

  setTabs(tabs: TabVm[]): void {
    this.tabsInfo = tabs;
    this.tabsLoaded = true;
  }

  getTabs(): TabVm[] {
    return this.tabsInfo;
  }

  getCurrentTab(): TabVm | undefined {
    const currentTabId = this.currenttabid || this.tabsInfo?.[0]?.id;
    return this.tabsInfo?.find((element) => element.id === currentTabId);
  }

  getTab(tabId: string): TabVm | undefined {
    const currentTabId = tabId || this.tabsInfo?.[0]?.id;
    return this.tabsInfo.find((element) => element.id === currentTabId);
  }

  cleanUp() {
    this.currenttabid = '';
    this.currenttabname = '';
  }
}
